import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { I18n } from '../i18n.service';
import { HomeUiService } from '../new-design/home-ui.service';


@Component({
  selector: 'app-habit-description-modal',
  templateUrl: './habit-description-modal.component.html',
  styleUrls: ['./habit-description-modal.component.scss'],
})
export class HabitDescriptionModalComponent implements OnInit {
  @Input() habitLevel;

  constructor(private modal: ModalController, public homeUiService: HomeUiService, private i18n: I18n) {}

  ngOnInit() {}

  closePopup() {
    this.modal.dismiss();
  }
}
